import { createAction, props } from "@ngrx/store";
import { Chips, TableType } from "@soposopo/sopo-models";
import { GameStateId } from "../game/game.state";

export const allInSignaledAction = createAction(
    'ALL_IN_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const betSignaledAction = createAction(
    'BET_SIGNALED',
    props<{
        bet: Chips;
        gameStateId: GameStateId;
    }>()
)

export const callSignaledAction = createAction(
    'CALL_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const callAnySignaledAction = createAction(
    'CALL_ANY_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const checkSignaledAction = createAction(
    'CHECK_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const checkOrFoldSignaledAction = createAction(
    'CHECK_OR_FOLD_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const dealerSignalAcceptedAction = createAction(
    '[sopo-websockets-service] DEALER_SIGNAL_ACCEPTED',
    props<{
        message: string;
    }>()
)

export const dealerResetAction = createAction(
    'DEALER_RESET',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const foldSignaledAction = createAction(
    'FOLD_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const forfeitSignaledAction = createAction(
    'FORFEIT_SIGNALED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const gameSocketConnectedAction = createAction(
    'GAME_SOCKET_CONNECTED',
    props<{
        gameStateId: GameStateId;
        socketId: string;
    }>()
)

export const gameSocketDisconnectedAction = createAction(
    'GAME_SOCKET_DISCONNECTED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const gameSocketCreatedAction = createAction(
    'GAME_SOCKET_CREATED',
    props<{
        gameStateId: GameStateId;
        gameServerId: string;
        url: string;
        gameType: TableType;
    }>()
)

export const createGameSocketAction = createAction(
    'CREATE_GAME_SOCKET',
    props<{
        gameStateId: GameStateId;
        url: string;
        gameType: TableType;
    }>()
)

export const raiseSignaledAction = createAction(
    'RAISE_SIGNALED',
    props<{
        raise: Chips;
        gameStateId: GameStateId;
    }>()
)

export const signalFailedToSendAction = createAction(
    'SIGNAL_FAILED_TO_SEND',
    props<{
        reason: string;
    }>()
)

export const signalRejectedAction = createAction(
    'SIGNAL_REJECTED',
    props<{
        reason: string;
    }>()
)

export const tableSignalAcceptedAction = createAction(
    '[sopo-websockets-service] TABLE_SIGNAL_ACCEPTED',
    props<{
        message: string;
    }>()
)

export const topUpSignaledAction = createAction(
    'TOP_UP_SIGNALED',
    props<{
        amount: number;
        isBuyIn: boolean;
        nextMaxBuyIn: number;
        gameStateId: GameStateId;
    }>()
)

export const removeGameSocket = createAction(
    '[SOCKET] REMOVE_GAME_SOCKET',
    props<{
        gameStateId: GameStateId;
    }>()
)
